import PropTypes from 'prop-types';

import RadioButton from './RadioButton';

import { RadioButtonGroupWrapper } from './RadioButtonGroup.style';

const RadioButtonGroup = ({ RadioButtonGroupArr, selectedRadioButton, handleRadioButtonClick }) => (
  <RadioButtonGroupWrapper>
    {RadioButtonGroupArr.map(radioButtonObj => (
      <RadioButton
        key={radioButtonObj.key}
        RadioButtonObj={radioButtonObj}
        checked={radioButtonObj.key === selectedRadioButton.key}
        handleRadioButtonClick={handleRadioButtonClick}
      />
    ))}
  </RadioButtonGroupWrapper>
);

RadioButtonGroup.propTypes = {
  RadioButtonGroupArr: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  selectedRadioButton: PropTypes.shape({
    key: PropTypes.string,
  }).isRequired,
  handleRadioButtonClick: PropTypes.func.isRequired,
};

export default RadioButtonGroup;
